import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ViewMobile = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const viewData = location.state?.quotationData || [];

    const [viewQuotation] = useState(viewData);

    const data = {
        fullName: viewQuotation.full_name,
        email: viewQuotation.email,
        phone: viewQuotation.phone,
        eventDate: viewQuotation.event_date,
        startTime: viewQuotation.event_start_time,
        endTime: viewQuotation.event_end_time,
        eventType: viewQuotation.event_type,
        otherEventType: viewQuotation.event_type_other,
        guests: viewQuotation.no_of_guest,
        venueName: viewQuotation.venue_name,
        venueAddress: viewQuotation.address,
        vendorAccess: viewQuotation.easy_loading,
        barSetup: viewQuotation.bar_type,
        numBartenders: viewQuotation.bartenders,
        alcoholProvision: viewQuotation.alcohol_provision,
        drinkStyles: viewQuotation.drink_style.map((pre) => pre),
        glassware: viewQuotation.glassware,
        brandedElements: viewQuotation.branded_elements,
        budget: viewQuotation.budget_range,
        notes: viewQuotation.note,
        status: viewQuotation.status
    };

    return (
        <>
            <div className="page-content px-4" style={{ zIndex: '1' }}>
                <div className="container-fluid">
                    {/* //* start page title */}
                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2">
                                <h4 className="mb-2 mb-sm-0">View Quotation</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0 d-flex flex-wrap gap-1">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active pointer" onClick={() => navigate(-1)}>Quotations</li>
                                        <li className="breadcrumb-item active">View Quotation</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="p-6 rounded row">

                                    {/* //* Contact Information */}
                                    <div className="mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                        <div className=" rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4 className="text-xl fw-bold  mb-0 quotation-title py-2 px-3" style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Contact Information</h4>

                                            <div className="p-3">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <strong>Full Name:</strong>
                                                    <span>{data.fullName}</span>
                                                </div>

                                                <div className="d-flex justify-content-between mb-2">
                                                    <strong>Email:</strong>
                                                    <span>{data.email}</span>
                                                </div>

                                                <div className="d-flex justify-content-between mb-0">
                                                    <strong>Phone:</strong>
                                                    <span>{data.phone}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Event Details */}
                                    <div className="mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                        <div className="rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4
                                                className="text-xl fw-bold mb-0 quotation-title py-2 px-3"
                                                style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}
                                            >
                                                Event Details
                                            </h4>

                                            <div className="p-3">
                                                <div className="row">
                                                    {/* Column 1 */}
                                                    <div className="col-12 col-sm-6">
                                                        <div className="d-flex justify-content-between mb-2">
                                                            <strong>Date:</strong>
                                                            <span>{data.eventDate}</span>
                                                        </div>

                                                        <div className="d-flex justify-content-between mb-2">
                                                            <strong>Bar Start Time:</strong>
                                                            <span>{data.startTime}</span>
                                                        </div>

                                                        <div className="d-flex justify-content-between">
                                                            <strong>Bar End Time:</strong>
                                                            <span>{data.endTime}</span>
                                                        </div>
                                                    </div>

                                                    {/* Column 2 */}
                                                    <div className="col-12 col-sm-6">
                                                        <div className="d-flex justify-content-between mb-2">
                                                            <strong>Event Type:</strong>
                                                            <span>{data.eventType === 'Other' ? data.otherEventType : data.eventType}</span>
                                                        </div>

                                                        <div className="d-flex justify-content-between mb-0">
                                                            <strong>Guests:</strong>
                                                            <span>{data.guests}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Location Details */}
                                    <div className="mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 ">
                                        <div className=" rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4 className="text-xl fw-bold  mb-0 quotation-title py-2 px-3" style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Location Details</h4>

                                            <div className="p-3">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <strong>Venue Name:</strong>
                                                    <span>{data.venueName || 'N/A'}</span>
                                                </div>

                                                <div className="d-flex justify-content-between mb-2">
                                                    <strong>Address:</strong>
                                                    <span>{data.venueAddress}</span>
                                                </div>

                                                <div className="d-flex justify-content-between mb-0">
                                                    <strong>Loading Access:</strong>
                                                    <span>{data.vendorAccess}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Bar Requirements */}
                                    <div className="mb-4 mb-xxl-0 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                        <div className="rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4
                                                className="text-xl fw-bold mb-0 quotation-title py-2 px-3"
                                                style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}
                                            >
                                                Bar Requirements
                                            </h4>

                                            <div className="p-3">
                                                <div className="row mb-2">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Bar Setup:</div>
                                                    <div className="col-6 col-md-8 text-start">{data.barSetup}</div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Bartenders:</div>
                                                    <div className="col-6 col-md-8 text-start">{data.numBartenders}</div>
                                                </div>

                                                {data.specificBartenders && (
                                                    <div className="row mb-2">
                                                        <div className="col-6 col-md-4 fw-bold text-nowrap">Specific Number:</div>
                                                        <div className="col-6 col-md-8 text-start">{data.specificBartenders}</div>
                                                    </div>
                                                )}

                                                <div className="row mb-2">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Alcohol:</div>
                                                    <div className="col-6 col-md-8 text-start">{data.alcoholProvision}</div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Preferred Drinks:</div>
                                                    <div className="col-6 col-md-8 text-start" style={{ textAlign: 'justify' }}>
                                                        {data.drinkStyles.join(', ')}
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Glassware:</div>
                                                    <div className="col-6 col-md-8 text-start">{data.glassware}</div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-6 col-md-4 fw-bold text-nowrap">Branded Elements:</div>
                                                    <div className="col-6 col-md-8 text-start">{data.brandedElements}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Budget Range */}
                                    <div className=" mb-4 mb-md-0  col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                        <div className=" rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4 className="text-xl fw-bold  mb-0 quotation-title py-2 px-3" style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Budget Range</h4>
                                            <div className="p-3">
                                                <div className="d-flex justify-content-between">
                                                    <strong>Budget Range:</strong>
                                                    <span>{data.budget}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Additional Notes */}
                                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 ">
                                        <div className=" rounded shadow-sm" style={{ background: '#e8fff4' }}>
                                            <h4 className="text-xl fw-bold  mb-0 quotation-title py-2 px-3" style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Additional Notes</h4>

                                            <div className="p-3">
                                                <div className="d-flex justify-content-between">
                                                    <span >{data.notes || 'None'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ViewMobile